// Generated by purs version 0.15.0
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_ItemId from "../Restaumatic.Menu.V2.Types.ItemId/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Types_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
var inProductSingleFilter = function (product) {
    return function (v) {
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ItemIdFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_ItemId.eqItemId))(Restaumatic_PromotionsEngine_Cart_ProductItem.itemId(product))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value0));
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ProductCategoryIdFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(Restaumatic_PromotionsEngine_Cart_ProductItem.productCategoryId(product))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value0));
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.ParameterValueFilter) {
            return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(Restaumatic_PromotionsEngine_Cart_ProductItem.customParameterValues(product)(v.value0))(Data_Functor.map(Data_Functor.functorArray)(Data_Maybe.Just.create)(v.value1));
        };
        if (v instanceof Restaumatic_PromotionsEngine_Promotions_Types_Promotion.AnyComboFilter) {
            return Restaumatic_PromotionsEngine_Cart_ProductItem.isCombo(product);
        };
        throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.ProductFilter (line 28, column 1 - line 28, column 83): " + [ product.constructor.name, v.constructor.name ]);
    };
};
var inProductFilter = function (productItem) {
    return Data_Foldable.all(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)(inProductSingleFilter(productItem));
};
export {
    inProductFilter,
    inProductSingleFilter
};
export {
    AnyComboFilter,
    ItemIdFilter,
    ParameterValueFilter,
    ProductCategoryIdFilter
} from "../Restaumatic.PromotionsEngine.Promotions.Types.Promotion/index.js";
//# sourceMappingURL=index.js.map
